import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentToEmailComponent } from './sent-to-email.component';
import { TranslateModule } from '@xref/ngx';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BlogPostsModule } from 'src/app/components/blog-posts/blog-posts.module';
import { FooterMarketingModule } from 'src/app/components/footer-marketing/footer-marketing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { defaultPageScrollConfig, NGXPS_CONFIG } from 'ngx-page-scroll-core';

@NgModule({
  declarations: [SentToEmailComponent],
  exports: [SentToEmailComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FontAwesomeModule,
    BlogPostsModule,
    FooterMarketingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule
  ],
  providers: [
    {provide: NGXPS_CONFIG, useValue: defaultPageScrollConfig}
  ]
})
export class SentToEmailModule {}
